import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text } from "@ui-component-library";

const HeroText = (props) => {
  return (
    <TailwindWrapper>
      <section className="w-full py-12 bg-white container">
        <div className="flex flex-col items-center max-w-[576px] mx-auto text-center ">
          {/* Hero section name */}
          <Text
            tw
            variant="overlineLargeRegular"
            className="text-[#737373] mb-4"
          >
            {props.sectionName}
          </Text>
          {/* Main Headline */}
          <Text
            tw
            variant="text-3xl/leading-normal/medium"
            className="mb-6 max-w-[500px]"
          >
            {props.title}
          </Text>
          {/* Description Text */}
          <Text
            tw
            className="text-[#737373]"
            variant="text-base/leading-normal/normal"
          >
            {props.text}
          </Text>
        </div>
      </section>
    </TailwindWrapper>
  );
};

HeroText.defaultProps = {
  sectionName: "Bento grid section",
  title: "Feature-rich layout that captures attention",
  text: "Add a concise value statement that highlights your product's key features and benefits in a visually dynamic grid. Focus on creating balanced content blocks while keeping it under 2-3 lines. Align with your grid layout structure.",
};

HeroText.fields = {
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
};

export default HeroText;
